import React from "react";
import PropTypes from "prop-types";

function CollectionImageCaptionItem({ url, caption, aspectRatio }) {
    return (
        <figure className="CollectionCortisImageCaption">
            <div className="CollectionCortisImageCaption-media" style={aspectRatio ? { aspectRatio } : undefined}>
                <img className="CollectionCortisImageCaption-image" src={url} alt={caption || ''} loading="lazy" />
            </div>
            {caption && <figcaption className="CollectionCortisImageCaption-caption">{caption}</figcaption>}
        </figure>
    );
}

CollectionImageCaptionItem.propTypes = {
    url: PropTypes.string.isRequired,
    caption: PropTypes.string,
    aspectRatio: PropTypes.number,
};

export default React.memo(CollectionImageCaptionItem);
